module.exports = __webpack_public_path__ + "img/about-banner.bca3bcc0.jpg";